// src/components/AddUserModal.js

import React, { useState } from 'react';
import { addUser } from '../api/quontxApi';

const AddUserModal = ({ isOpen, onClose, onUserAdded }) => {
  const initialFormData = {
    name: '',
    username: '',
    email: '',
    password: '',
    is_superuser: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.password) {
      setError('Password is required.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await addUser(formData);
      onUserAdded(); // Notify parent to refresh the user list
      onClose();     // Close the modal on success
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'An unknown error occurred.';
      setError(`Failed to create user: ${errorMessage}`);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Reset form state when the modal is closed
  const handleClose = () => {
    setFormData(initialFormData);
    setError('');
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
      <div className="bg-qtx-darker p-8 rounded-lg shadow-2xl w-full max-w-md">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">Add New User</h2>
          <button onClick={handleClose} className="text-qtx-gray hover:text-white text-2xl">×</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" required className="w-full p-3 bg-qtx-dark text-white rounded-md border border-qtx-dark focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="text" name="username" value={formData.username} onChange={handleChange} placeholder="Username" required className="w-full p-3 bg-qtx-dark text-white rounded-md border border-qtx-dark focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" required className="w-full p-3 bg-qtx-dark text-white rounded-md border border-qtx-dark focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Password" required className="w-full p-3 bg-qtx-dark text-white rounded-md border border-qtx-dark focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <div className="flex items-center">
            <input type="checkbox" id="is_superuser" name="is_superuser" checked={formData.is_superuser} onChange={handleChange} className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
            <label htmlFor="is_superuser" className="ml-2 block text-sm text-qtx-light-gray">Make Superuser</label>
          </div>
          {error && <div className="text-red-400 text-sm p-3 bg-red-900 bg-opacity-30 rounded-md">{error}</div>}
          <div className="flex justify-end pt-4">
            <button type="button" onClick={handleClose} className="text-qtx-light-gray hover:text-white px-4 py-2 mr-2 rounded-md">Cancel</button>
            <button type="submit" disabled={loading} className="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-900 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded transition-colors duration-200">
              {loading ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;